function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SpainFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_4087",
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 24,
    height: 18,
    children: /*#__PURE__*/_jsx("path", {
      fill: "#fff",
      d: "M0 3h24v18H0z"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_4087)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#FFB400"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_4087",
      style: {
        maskType: 'alpha'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_4087)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V7.5H24V3H0Z",
        fill: "#C51918"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 16.5V21H24V16.5H0Z",
        fill: "#C51918"
      }), /*#__PURE__*/_jsx("rect", {
        x: "3.75604",
        y: "10.704",
        width: "0.84",
        height: "4.368",
        fill: "#F1F9FF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.93204 9.94799H3.42004V10.368H3.67206V10.704H4.68006V10.368H4.93204V9.94799Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.68004 15.324H4.93204V15.744H3.42004V15.324H3.67204V14.988H4.68004V15.324Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.17601 10.032C4.35881 10.032 4.37739 9.96316 4.48524 9.86036C4.56898 9.78053 4.76401 9.68152 4.76401 9.56999C4.76401 9.31484 4.50076 9.10799 4.17601 9.10799C3.85127 9.10799 3.58801 9.31484 3.58801 9.56999C3.58801 9.69424 3.72232 9.77732 3.82388 9.86036C3.93087 9.94784 4.00941 10.032 4.17601 10.032Z",
        fill: "#AD1619"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.42004 15.744H4.93204V16.416C4.93204 16.416 4.74304 16.332 4.55404 16.332C4.36504 16.332 4.17604 16.416 4.17604 16.416C4.17604 16.416 3.98704 16.332 3.79804 16.332C3.60904 16.332 3.42004 16.416 3.42004 16.416V15.744Z",
        fill: "#005BBF"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_4087",
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "3",
        y: "15",
        width: "2",
        height: "2",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.42004 15.744H4.93204V16.416C4.93204 16.416 4.74304 16.332 4.55404 16.332C4.36504 16.332 4.17604 16.416 4.17604 16.416C4.17604 16.416 3.98704 16.332 3.79804 16.332C3.60904 16.332 3.42004 16.416 3.42004 16.416V15.744Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask2_621_4087)"
      }), /*#__PURE__*/_jsx("rect", {
        x: "11.988",
        y: "10.704",
        width: "0.839998",
        height: "4.368",
        fill: "#F1F9FF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.164 9.94799H11.652V10.368H11.9041V10.704H12.9121V10.368H13.164V9.94799Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.912 15.324H13.164V15.744H11.652V15.324H11.904V14.988H12.912V15.324Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.408 10.032C12.5908 10.032 12.6094 9.96316 12.7172 9.86036C12.801 9.78053 12.996 9.68152 12.996 9.56999C12.996 9.31484 12.7328 9.10799 12.408 9.10799C12.0833 9.10799 11.82 9.31484 11.82 9.56999C11.82 9.69424 11.9543 9.77732 12.0559 9.86036C12.1629 9.94784 12.2414 10.032 12.408 10.032Z",
        fill: "#AD1619"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.652 15.744H13.164V16.416C13.164 16.416 12.975 16.332 12.786 16.332C12.597 16.332 12.408 16.416 12.408 16.416C12.408 16.416 12.219 16.332 12.03 16.332C11.841 16.332 11.652 16.416 11.652 16.416V15.744Z",
        fill: "#005BBF"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask3_621_4087",
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "11",
        y: "15",
        width: "3",
        height: "2",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.652 15.744H13.164V16.416C13.164 16.416 12.975 16.332 12.786 16.332C12.597 16.332 12.408 16.416 12.408 16.416C12.408 16.416 12.219 16.332 12.03 16.332C11.841 16.332 11.652 16.416 11.652 16.416V15.744Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: "url(#mask3_621_4087)"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5295 14.2319C12.5295 14.4093 12.6142 14.5763 12.7656 14.7599L13.2814 14.3345L13.3307 14.3194L13.3581 14.1044C13.4088 13.7073 13.2391 13.4873 12.8894 13.3283L12.8653 13.3177L12.8652 13.3177C12.8173 13.2966 12.7128 13.2507 12.6775 13.2338C12.6036 13.1984 12.5428 13.1633 12.486 13.122C12.4299 13.0813 12.3698 13.0428 12.2973 13.0007C12.7301 12.9312 12.9639 12.8799 13.1433 12.8026C13.5727 12.6177 13.628 12.1881 13.2154 11.9039C12.6528 11.5165 11.1467 11.4816 10.4857 11.8229L10.794 12.42C11.1184 12.2525 11.8558 12.2209 12.3722 12.3069C12.2937 12.3206 12.2056 12.3351 12.1069 12.3506L11.8547 12.3897L11.8119 12.3963C11.6056 12.4283 11.4649 12.4691 11.3606 12.5401C11.1478 12.685 11.1162 12.9461 11.2681 13.1387C11.3322 13.22 11.4161 13.2808 11.543 13.3544C11.5837 13.3781 11.6275 13.4021 11.6864 13.4335L11.717 13.4498L11.8309 13.5104C11.952 13.5754 12.0314 13.6224 12.0907 13.6655C12.1836 13.733 12.2788 13.7879 12.3869 13.8398C12.4451 13.8676 12.6121 13.9405 12.6112 13.94L12.6211 13.9445C12.5628 14.0234 12.5295 14.12 12.5295 14.2319ZM3.741 14.7599C3.89245 14.5763 3.97713 14.4093 3.97713 14.2319C3.97713 14.12 3.94385 14.0234 3.88553 13.9445L3.89538 13.94C3.89447 13.9405 4.06152 13.8676 4.11968 13.8398C4.22779 13.7879 4.32304 13.733 4.41591 13.6655C4.4752 13.6224 4.55464 13.5754 4.67573 13.5104L4.78956 13.4498L4.82025 13.4335C4.87911 13.4021 4.92294 13.3781 4.96365 13.3544C5.09053 13.2808 5.17437 13.22 5.2385 13.1387C5.39039 12.9461 5.35886 12.685 5.14601 12.5401C5.04173 12.4691 4.90101 12.4283 4.69474 12.3963L4.65197 12.3897L4.39972 12.3506C4.30101 12.3351 4.21294 12.3206 4.13441 12.3069C4.65083 12.2209 5.38826 12.2525 5.71263 12.42L6.02093 11.8229C5.35992 11.4816 3.85382 11.5165 3.29122 11.9039C2.87857 12.1881 2.93395 12.6177 3.36329 12.8026C3.54269 12.8799 3.77656 12.9312 4.20935 13.0007C4.13682 13.0428 4.07669 13.0813 4.02067 13.122C3.96385 13.1633 3.90297 13.1984 3.82914 13.2338C3.79382 13.2507 3.68924 13.2967 3.64132 13.3177L3.64132 13.3177L3.61722 13.3283C3.26751 13.4873 3.09778 13.7073 3.1485 14.1044L3.17596 14.3194L3.2252 14.3345L3.741 14.7599ZM3.3087 14.2044L3.30764 14.2075L3.30845 14.2053L3.3087 14.2044Z",
        fill: "#AD1619"
      }), /*#__PURE__*/_jsx("path", {
        d: "M4.44256 12.3L4.6905 12.3513V12.7208C4.42643 12.9315 3.75604 13.2867 3.75604 13.2867V12.3H4.44256Z",
        fill: "#F1F9FF"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.236 12.3L11.988 12.3513V12.7208C12.2521 12.9315 12.9225 13.2867 12.9225 13.2867V12.3H12.236Z",
        fill: "#F1F9FF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.082 8.40448V8.28149C10.6499 7.97141 10.1975 7.81637 9.72461 7.81637C9.2713 7.61576 8.81245 7.53789 8.34807 7.58276C8.3482 7.58133 8.34827 7.5806 8.34827 7.5806C7.65003 7.51228 6.94636 7.81637 6.94636 7.81637C6.23708 7.81637 5.58899 8.2815 5.58899 8.2815V8.40449L6.43621 9.25538C6.43621 9.25538 6.6746 10.0741 8.34392 9.88199C8.34451 9.88331 8.34482 9.88397 8.34482 9.88397C8.34482 9.88397 9.45058 9.85379 9.52828 9.82794C9.5591 9.81769 9.59108 9.80836 9.62375 9.79882C9.84034 9.73558 10.0876 9.6634 10.2348 9.25538L11.082 8.40448ZM8.34427 7.62676C8.34078 7.66804 8.33524 7.73522 8.3287 7.82112C8.33701 7.75956 8.34258 7.69497 8.34427 7.62676Z",
        fill: "#AD1619"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.63983 8.54883L5.69739 8.48766L6.46666 9.2114C6.61269 9.17214 7.40531 8.97016 8.29067 8.96022V8.95984L8.32435 8.95993L8.35803 8.95984V8.96022C9.33895 8.97124 10.206 9.21798 10.206 9.21798C10.206 9.21798 10.1967 9.29759 10.1742 9.39119C10.1981 9.3422 10.2264 9.28775 10.2591 9.22766L10.2672 9.21715L11.0426 8.48766L11.1001 8.54883L10.3297 9.27372C10.2172 9.48074 10.1606 9.61738 10.1606 9.67414C10.1606 9.76074 9.93535 9.81214 9.49565 9.86493C9.15119 9.90629 8.74467 9.93405 8.41214 9.9382V9.93874L8.36998 9.9386L8.32783 9.93874V9.9382C7.9953 9.93405 7.58878 9.90629 7.24431 9.86493C6.80462 9.81214 6.57933 9.76074 6.57933 9.67414C6.57933 9.66341 6.5773 9.64981 6.57326 9.63343C6.52891 9.57696 6.49774 9.48458 6.47699 9.40125C6.45753 9.36229 6.4353 9.31974 6.41031 9.27372L5.63983 8.54883ZM9.93978 9.67579C9.99864 9.70333 10.0458 9.67586 10.0831 9.62312C10.0799 9.63769 10.0779 9.65085 10.0771 9.66265C10.0721 9.66587 10.0646 9.66976 10.0547 9.67392C10.027 9.68556 9.98474 9.69795 9.92976 9.71049C9.82171 9.73514 9.66791 9.75964 9.48564 9.78153C9.1297 9.82426 8.70646 9.85239 8.36998 9.8546C8.03351 9.85239 7.61027 9.82426 7.25433 9.78153C7.07205 9.75964 6.91825 9.73514 6.8102 9.71049C6.76413 9.69998 6.72698 9.68957 6.69987 9.67963C6.70285 9.67849 6.70587 9.67721 6.70891 9.67579C6.89241 9.58993 8.10583 9.50935 8.32435 9.49544C8.54287 9.50935 9.75629 9.58993 9.93978 9.67579ZM10.1712 9.6604L10.1699 9.66187L10.1707 9.6608L10.1712 9.6604Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.33415 7.0103C8.47333 7.0103 8.58615 6.89748 8.58615 6.7583C8.58615 6.61913 8.47333 6.5063 8.33415 6.5063C8.19498 6.5063 8.08215 6.61913 8.08215 6.7583C8.08215 6.89748 8.19498 7.0103 8.33415 7.0103Z",
        fill: "#005BBF"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.24013 6.05745H8.41513V6.168H8.52949V6.343H8.41513V6.693H8.52949V6.868H8.12402V6.693H8.24013V6.343H8.12402V6.168H8.24013V6.05745Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("rect", {
        x: "8.20801",
        y: "7.008",
        width: "0.336",
        height: "1.092",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        d: "M5.78082 8.47265L5.3194 8.4553C5.5371 7.1971 6.60928 6.58063 8.32259 6.58063C10.0381 6.58063 11.1065 7.19977 11.3079 8.46264L10.6838 8.5281C10.5858 7.91355 9.55647 7.35739 8.33161 7.35739C7.10454 7.35739 5.88796 7.85341 5.78082 8.47265Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        opacity: "0.3",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.604 9.948H11.064V14.8536C11.064 14.8536 10.6584 16.5 8.334 16.5C6.00959 16.5 5.604 14.8102 5.604 14.8102V9.948Z",
        fill: "#E1E5E8"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask4_621_4087",
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "5",
        y: "9",
        width: "7",
        height: "8",
        children: /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.604 9.948H11.064V14.8536C11.064 14.8536 10.6584 16.5 8.334 16.5C6.00959 16.5 5.604 14.8102 5.604 14.8102V9.948Z",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask4_621_4087)",
        children: [/*#__PURE__*/_jsx("rect", {
          x: "5.604",
          y: "12.972",
          width: "2.772",
          height: "3.276",
          fill: "#FFC034"
        }), /*#__PURE__*/_jsx("rect", {
          x: "5.604",
          y: "9.864",
          width: "2.772",
          height: "3.192",
          fill: "#AD1619"
        }), /*#__PURE__*/_jsx("rect", {
          x: "8.29199",
          y: "12.888",
          width: "2.772",
          height: "3.192",
          fill: "#AD1619"
        }), /*#__PURE__*/_jsx("rect", {
          x: "8.29199",
          y: "9.948",
          width: "2.94",
          height: "3.108",
          fill: "#F1F9FF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.1121 16.082C10.1121 16.082 8.33291 16.2219 8.33291 15.0744C8.33291 15.0744 8.31594 16.082 6.45819 16.082V16.9879H10.1121V16.082Z",
          fill: "#F1F9FF"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.33404 13.644C8.68198 13.644 8.96404 13.3431 8.96404 12.972C8.96404 12.6009 8.68198 12.3 8.33404 12.3C7.9861 12.3 7.70404 12.6009 7.70404 12.972C7.70404 13.3431 7.9861 13.644 8.33404 13.644Z",
          fill: "#005BBF",
          stroke: "#AD1619",
          strokeWidth: "0.583333"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.75 12C7.16421 12 7.5 11.6642 7.5 11.25C7.5 10.8358 7.16421 10.5 6.75 10.5C6.33579 10.5 6 10.8358 6 11.25C6 11.6642 6.33579 12 6.75 12Z",
        fill: "#C88A02"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 12C10.1642 12 10.5 11.6642 10.5 11.25C10.5 10.8358 10.1642 10.5 9.75 10.5C9.33579 10.5 9 10.8358 9 11.25C9 11.6642 9.33579 12 9.75 12Z",
        fill: "#C37C9C"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 15C10.1642 15 10.5 14.6642 10.5 14.25C10.5 13.8358 10.1642 13.5 9.75 13.5C9.33579 13.5 9 13.8358 9 14.25C9 14.6642 9.33579 15 9.75 15Z",
        fill: "#FFC034"
      }), /*#__PURE__*/_jsx("path", {
        d: "M6.75 15C7.16421 15 7.5 14.6642 7.5 14.25C7.5 13.8358 7.16421 13.5 6.75 13.5C6.33579 13.5 6 13.8358 6 14.25C6 14.6642 6.33579 15 6.75 15Z",
        fill: "#AD1619"
      })]
    })]
  })]
}));
//# sourceMappingURL=Spain.js.map